<template>
<div>
  <form>
    <div class="columns">
      <div class="column">
        <text-input 
          v-model="section.title"
          :error="$root.errorBag.title"
          required>
          Title
        </text-input>
      </div>
    </div>  
    <div class="columns">
      <div class="column">
        <text-area 
          v-model="section.description"
          :error="$root.errorBag.description"
          required>
          Description
        </text-area>

        <submit-button :working="saving" @submit="saveSection">Save</submit-button>
      </div>
    </div>  
  </form>  
</div>  
</template>
<script>
import { updateSection, loadSection } from '@/api/super'

export default {

  data: () => ({
    saving: false,
    section: {
      title: '',
      description: ''
    }
  }),

  beforeCreate() {
    loadSection(this.$route.params.section, ({data}) => {
      this.section = data
    })
  },

  methods: {
    saveSection() {
      this.saving = true
      updateSection(this.section, () => {
        this.saving = false
        this.$toast.success('saved')
      }, error => {
        this.saving = false
        this.$toast.error('whoops')
      })
    }
  }

}
</script>